import { AfterViewInit, Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ChargesService } from 'src/app/services/system-config/charges/charges.service';
import { CustomerService } from 'src/app/services/customer.service';
import { GeoService } from 'src/app/services/geo.service';
import { ProductService } from 'src/app/services/products.service';
import { VendorService } from 'src/app/services/vendor.service';
import Swal from 'sweetalert2';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, map, from, lastValueFrom } from 'rxjs';
import { AppCoreService } from 'src/app/services/app-core.service';
import { Utilities } from 'src/app/models/utilities';
import { TATService } from 'src/app/services/system-config/tat/tat.service';

@Component({
    selector: 'app-tatdetails',
    templateUrl: './tatdetails.component.html',
    styleUrls: ['./tatdetails.component.scss']
})
export class TATDetailsComponent implements AfterViewInit {
    @Input() detailData: any;
    Id: number;
    countryList: [];
    countryCode: any;
    detailsForm: FormGroup;
    isFormSubmitted = false;
    customerOptions: any[] = [];
    vendorOptions: any[] = [];
    productOptions: any[] = [];
    serviceOptions: any[] = [];
    destinationCountryList: any[] = [];
    destinationStateList: any[] = [];
    destinationCityList: any[] = [];

    originCountryList: any[] = [];
    originStateList: any[] = [];
    originCityList: any[] = [];
    pincodeList = []
    public context: any;
    useEnterKey: any;

    constructor(
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private geoService: GeoService,
        private ngxLoaderService: NgxUiLoaderService,
        private chargesService: ChargesService,
        private customerService: CustomerService,
        private vendorService: VendorService,
        private productService: ProductService,
        public activeModal: NgbActiveModal,
        private appCoreService: AppCoreService,
        private utilities: Utilities,
        private tatService: TATService,
    ) { this.context = { componentParent: this }; }

    async ngOnInit() {
        this.detailsForm = this.formBuilder.group({
            ddlVendor: [],
            ddlProduct: [],
            ddlOriginCountry: [null],
            ddlOriginState: [null],
            ddlOriginCity: [null],
            txtOriginPincode: [null],
            ddlDestinationCountry: [null],
            ddlDestinationState: [null],
            ddlDestinationCity: [null],
            txtDestinationPincode: [null],
            txtDays: [0, [Validators.required, Validators.max(10)]],
            txtHours: [0, [Validators.required, Validators.max(23)]],
            txtFixedTime: [0, Validators.max(23)],
        });
        await this.bindPincodes();
        await this.bindCustomer();
        await this.bindVendor();
        await this.bindProduct();
        await this.bindCountry();
        this.bindFields(this.detailData);

        // const userData = this.appCoreService.GetUserData();
        // this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.detailsForm) : null;
    }

    async bindFields(cell: any) {
        if (cell) {
            this.Id = cell?.id;
            
            //bind time 
            this.detailsForm.get('txtDays').setValue(cell?.days);
            this.detailsForm.get('txtHours').setValue(cell?.hours);
            this.detailsForm.get('txtFixedTime').setValue(cell?.fixedtime);
            // console.log(this.pincodeList.find(x=>x.pincode === cell?.originpincode));

            this.detailsForm.get('txtOriginPincode').setValue(this.pincodeList.find(x=>x.pincode === cell?.originpincode));
            this.detailsForm.get('txtDestinationPincode').setValue(this.pincodeList.find(x=>x.pincode === cell?.destinationpincode));
            // Origin fields
            const origincountry: any = cell.origincountrycode ?
            this.originCountryList.find((item: any) => item.code == cell.origincountrycode) : cell.origincountrycode;
            this.detailsForm.get('ddlOriginCountry').setValue(origincountry?.isocode);
            await lastValueFrom(from(this.bindStatesByCountry(origincountry?.isocode)));
    
            const originstate: any = cell.originstatecode ?
                this.originStateList?.find((item: any) => item.code == cell.originstatecode) : cell.originstatecode;
            this.detailsForm.get('ddlOriginState').setValue(originstate?.isocode);
            await lastValueFrom(from(this.bindCitiesByState(originstate?.isocode)));
    
            const origincity: any = cell.origincitycode ?
                this.originCityList.find(x => x.code == cell.origincitycode) : cell.origincitycode;
            this.detailsForm.get('ddlOriginCity').setValue(origincity?.isocode);
            // Destination fields
            const destinationcountry: any = cell.destinationcountrycode ?
                this.destinationCountryList.find((item: any) => item.code == cell.destinationcountrycode) : cell.destinationcountrycode;
            this.detailsForm.get('ddlDestinationCountry').setValue(destinationcountry?.isocode);
            await lastValueFrom(from(this.bindStatesByCountry(destinationcountry?.isocode)));
    
            const destinationstate: any = cell.destinationstatecode ?
                this.destinationStateList?.find((item: any) => item.code == cell.destinationstatecode) : cell.destinationstatecode;
            this.detailsForm.get('ddlDestinationState').setValue(destinationstate?.isocode);
            await lastValueFrom(from(this.bindCitiesByState(destinationstate?.isocode)));
    
            const destinationcity: any = cell.destinationcitycode ?
                this.destinationCityList.find(x => x.code == cell.destinationcitycode) : cell.destinationcitycode;
            this.detailsForm.get('ddlDestinationCity').setValue(destinationcity?.isocode);
    
            // Product and vendor fields
            this.detailsForm.get('ddlProduct').setValue(this.productOptions.find(x => x.code == cell.productcode)?.id);
            this.detailsForm.get('ddlVendor').setValue(this.vendorOptions.find(x => x.code == cell.vendorcode)?.id);
        }
    }
    
    update() {
        this.isFormSubmitted = true;
        if (this.detailsForm.valid) {
            const originPincodeObj = this.detailsForm.get('txtOriginPincode').value;
            const originPincodeValue = typeof originPincodeObj === 'string'? originPincodeObj : originPincodeObj.pincode
            const destinationPincodeObj = this.detailsForm.get('txtDestinationPincode').value;
            const destinationPincodeValue = typeof destinationPincodeObj === 'string'? destinationPincodeObj : destinationPincodeObj.pincode
            const reqObj = {
                id: this.Id,
                days: this.detailsForm.get('txtDays').value,
                hours: this.detailsForm.get('txtHours').value,
                fixedtime: this.detailsForm.get('txtFixedTime').value,
                vendorcode: this.vendorOptions.filter(x => x.id === this.detailsForm.get('ddlVendor').value)[0]?.code,
                productcode: this.productOptions.filter(x => x.id === this.detailsForm.get('ddlProduct').value)[0]?.code,

                origincountrycode: this.originCountryList.filter(x => x.isocode === this.detailsForm.get('ddlOriginCountry').value)[0]?.code,
                originstatecode: this.originStateList.filter(x => x.isocode === this.detailsForm.get('ddlOriginState').value)[0]?.code,
                origincitycode: this.originCityList.filter(x => x.isocode === this.detailsForm.get('ddlOriginCity').value)[0]?.code,
                originpincode: originPincodeValue,

                destinationcountrycode: this.destinationCountryList.filter(x => x.isocode === this.detailsForm.get('ddlDestinationCountry').value)[0]?.code,
                destinationstatecode: this.destinationStateList.filter(x => x.isocode === this.detailsForm.get('ddlDestinationState').value)[0]?.code,
                destinationcitycode: this.destinationCityList.filter(x => x.isocode === this.detailsForm.get('ddlDestinationCity').value)[0]?.code,
                destinationpincode: destinationPincodeValue
            }
            //if (this.isMappingEdit) {
            this.ngxLoaderService.start();
            this.tatService.UpdateTATInfo(reqObj).subscribe((res) => {
                if (res && res.success) {
                    this.ngxLoaderService.stop();
                    this.appCoreService.showMessage('Record Saved Successfully.', 'Success', 'success')
                    this.activeModal.close('Save Click');
                }
                else if (res && !res.success) {
                    this.ngxLoaderService.stop();
                    this.openWarningMessageDialog(res.message);
                }
                this.ngxLoaderService.stop();
            });
        }
    }

    async bindCustomer() {
        this.customerService.GetAll('').subscribe((res) => {
            this.customerOptions = res?.success ? res.data : [];
        })
    }

    async bindVendor() {
        const res = await lastValueFrom(this.vendorService.GetAll(''));
        if (res && res.success) {
            this.vendorOptions = res?.success ? res.data : [];
        }
    }

    async bindProduct() {
        const res = await lastValueFrom(this.productService.GetAll(''));
        if (res && res.success) {
            this.productOptions = res?.success ? res.data : [];
        }
    }

    async bindCountry() {
        const observable = this.geoService.GetAllCountries();
        const res = await lastValueFrom(observable);
        if (res && res.success) {
            this.originCountryList = res.data;
            this.destinationCountryList = res.data;
        }
    }


    async bindStatesByCountry(countryCode?: string) {
        try {
            const observable = this.geoService.GetAllStates({ countrycode: countryCode });
            const res = await lastValueFrom(observable);
            if (res && res.success) {
                this.countryCode = countryCode;
                this.originStateList = res.data;
                this.destinationStateList = res.data;
            }
        } catch (e) {
            console.error(e);
        }
    }

    async bindCitiesByState(stateCode: string): Promise<void> {
        try {
            if (stateCode) {
                const observable = this.geoService.GetAllCities({ statecode: stateCode });
                const res = await lastValueFrom(observable);
                if (res && res.success) {
                    this.originCityList = res.data;
                    this.destinationCityList = res.data;
                }
            }
        }
        catch (e) {
            console.error(e);
        }
    }

    onOriginCountryChange() {
        const selectedValue = this.detailsForm.get('ddlOriginCountry').value;
        if (selectedValue) {
            this.bindStatesByCountry(selectedValue);
            this.detailsForm.get('ddlOriginState').reset();
            this.detailsForm.get('ddlOriginCity').reset();
            this.originCityList = [];
        }
    }

    onOriginStateChange() {
        const selectedValue = this.detailsForm.get('ddlOriginState').value;
        if (selectedValue) {
            this.bindCitiesByState(selectedValue);
            this.detailsForm.get('ddlOriginCity').reset();
        }
    }
    
    onDestinationCountryChange() {
        const selectedValue = this.detailsForm.get('ddlDestinationCountry').value;
        if (selectedValue) {
            this.bindStatesByCountry(selectedValue);
            this.detailsForm.get('ddlDestinationState').reset();
            this.detailsForm.get('ddlDestinationCity').reset();
            this.destinationCityList = [];
        }
    }

    onDestinationStateChange() {
        const selectedValue = this.detailsForm.get('ddlDestinationState').value;
        if (selectedValue) {
            this.bindCitiesByState(selectedValue);
            this.detailsForm.get('ddlDestinationCity').reset();
        }
    }

    async bindPincodes() {
        try {
          this.geoService.GetAllPincodes().subscribe((res) => {
            if (res && res.success) {
              this.pincodeList = res.data;
            } 
          });
        } catch (e) {
          console.error(e);
        }
      }

    async bindOriginByPincode(event: any) {
        try {
          this.detailsForm?.get('txtOriginPincode')?.clearValidators();
          if (event) {
            const pinObj = event.item;
            this.detailsForm.get('txtOriginPincode').clearValidators();
            this.detailsForm.get('txtOriginPincode').updateValueAndValidity();
            const foundPincode = this.pincodeList.filter((x: any) => pinObj.pincode == x.pincode);
            this.ngxLoaderService.start();
            if (foundPincode?.length > 0) {
              this.detailsForm.get('ddlOriginCountry').setValue(pinObj.countryisocode);
              await lastValueFrom(from(this.bindStatesByCountry(pinObj.countryisocode)));
              await lastValueFrom(from(this.bindCitiesByState(pinObj.stateisocode)));
              this.detailsForm.get('ddlOriginState').setValue(pinObj.stateisocode);
              this.detailsForm.get('ddlOriginCity').setValue(pinObj.cityisocode);
            }
            this.ngxLoaderService.stop();
          }
        } catch (error) {
          this.ngxLoaderService.stop();
          console.error(error);
        }
      }
      
    async bindDestinationByPincode(event: any) {
        try {
          this.detailsForm?.get('txtDestinationPincode')?.clearValidators();
          if (event) {
            const pinObj = event.item;
            this.detailsForm.get('txtDestinationPincode').clearValidators();
            this.detailsForm.get('txtDestinationPincode').updateValueAndValidity();
            const foundPincode = this.pincodeList.filter((x: any) => pinObj.pincode == x.pincode);
            this.ngxLoaderService.start();
            if (foundPincode?.length > 0) {
              this.detailsForm.get('ddlDestinationCountry').setValue(pinObj.countryisocode);
              await lastValueFrom(from(this.bindStatesByCountry(pinObj.countryisocode)));
              await lastValueFrom(from(this.bindCitiesByState(pinObj.stateisocode)));
              this.detailsForm.get('ddlDestinationState').setValue(pinObj.stateisocode);
              this.detailsForm.get('ddlDestinationCity').setValue(pinObj.cityisocode);
            }
            this.ngxLoaderService.stop();
          }
        } catch (error) {
          this.ngxLoaderService.stop();
          console.error(error);
        }
      }

      searchPincode: OperatorFunction<string, readonly { pincode; flag }[]> = (text$: Observable<string>) =>
      text$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        map((term) =>
          term === ''
            ? []
            : this.pincodeList.filter((v) => v.pincode.toLowerCase().startsWith(term.toLowerCase())).slice(0, 10),
        ),
      );
  
    pincodeFormatter = (x: { pincode: string }) => x.pincode;

    openWarningMessageDialog(msg: any) {
        Swal.fire({
            title: 'Warning!',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
    }
}
